import { RejectionMap } from './rejection-map';

export class RejectionTypeAndReasonsPayload {
  rejectionMap: RejectionMap;
  subtypes: string[];
}
